import {setParameterGroupList} from "./system-parameter-group.action";
import {ISystemParameterGroup} from "../models/system-parameter-group";

export interface ISystemParameterGroupState {
  systemParameterGroupList: ISystemParameterGroup[];
  loading: boolean,
}

const initialState: ISystemParameterGroupState = {
  systemParameterGroupList: [],
  loading: false,
};

export function systemParameterGroupReducer(state: ISystemParameterGroupState = initialState, action: any) {
  switch (action.type) {
    case setParameterGroupList:
      return {
        ...state,
        systemParameterGroupList: action.payload,
      };

    default:
      return state;
  }
}
